// --------------------------------------------------------------------------
// #?? – MAP MODULE
// --------------------------------------------------------------------------
// Author:
// Email:       frontend@thisiszone.com
// URL:         http://zonedigital.com
// Copyright:   Copyright (c) 2016, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');
var GoogleMapsLoader = require('google-maps');
GoogleMapsLoader.KEY = 'AIzaSyAp8yQAy-Y3pI6dPwDWFaMjxS47CgroM2w';
var mapResize = require('./map-resize');
var postal = require('postal');
var channel = postal.channel();
var MarkerClusterer;
var satelliteRoute;
var centerPoint;
var initialZoom;

module.exports = function (options) {
	var context = options.context;

	// infobox list that slides in
	var infoBoxListWrapper = $('[data-binding="info-box-list-wrapper"]');
	var infoBoxList = $('[data-binding="info-box-list"]');
	var closeInfoBoxList = $('[data-binding="close-info-box-list"]');
	//Pins
	var clusterPinUrl = '/Static/images/icons/cluster-map-pin.png';
	// Get reference to map element
	var mapElem = context.find('[data-bind="map"]');
	var infowindow = null;

	var navigation,
	    bounds,
	    mapMarkers = [],
	    polyLine;

	// Satellite tracking
	var numPointsAtLowZoom = 10;
	var numPointsAtMidZoom = 25;
	var numPointsAtHighZoom = 50;

	var maxZoomLevelForLowZoom = 5;
	var maxZoomLevelForMidZoom = 10;

	var satelliteLineCoords = [];

	var fullScreenToggle = false;
	/**
  * Generates the html for an infobox
  * @param  {Object} data - the data for the map pin
  * @return {string} html - string representing the html for the infobox
  */
	function createInfoBox(data) {
		var html = '<li class="info-box-list__item">' + '<img src="' + data.imageUrl + '">' + '<div class="text">' + '<h3 class="heading">' + data.title + '</h3>' + '<p class="info-text">' + data.infoText + '</p>' + '<a href="' + data.linkUrl + '" class="info-text">' + data.linkText + '</a>' + '</div>' + '</li>';
		return html;
	}

	function createMapPopup(google, map, title, event) {
		if (infowindow) {
			infowindow.close();
		}
		infowindow = new google.maps.InfoWindow({
			size: new google.maps.Size(150, 50)
		});
		var contentString = '<h2>' + title + '</h2>';
		infowindow.setContent(contentString);
		infowindow.setPosition(event.latLng);
		infowindow.open(map);
	}

	/**
 * Draws marker on map and binds click handler
 * @param  {object} google Google object
 * @param  {object} map    map object
 * @param  {object} marker marker object
 * @return {boolean}       default return value
 */
	function createMapMarker(google, map, marker) {
		var latLng = new google.maps.LatLng(marker.latitude, marker.longitude);
		var pinUrl = '/Static/images/icons/single-map-pin.png';

		var markerOnMap = new google.maps.Marker({
			icon: pinUrl,
			position: latLng,
			map: map,
			title: marker.title
		});

		var newHtml = createInfoBox(marker);

		google.maps.event.addListener(markerOnMap, 'click', function (event) {
			if (mapElem.parent().hasClass('standard-content__side-content')) {

				createMapPopup(google, map, this.title, event);
			} else {
				$(closeInfoBoxList).addClass('active');
				$(infoBoxListWrapper).addClass('active');
				$(infoBoxList).empty().append(newHtml);
			}
		});

		return markerOnMap;
	}

	/**
 * Loop through markers
 * @param  {object} google  Google object
 * @param  {object} map     Map object
 * @param  {array} 	markers [description]
 * @return {boolean}        default return value
 */
	function drawMarkers(google, map, markers) {
		//Config
		var markersArr = [];
		//Init cluster manager
		MarkerClusterer = require('../plugins/marker-clusterer')(google);

		for (var i = 0; i < markers.length; i++) {
			var thisMarker = createMapMarker(google, map, markers[i]);
			markersArr.push(thisMarker);
		}

		var clusterStyle = {
			backgroundPosition: '0px 9px',
			height: 68,
			textColor: '#fff',
			textSize: 14,
			url: clusterPinUrl,
			width: 48
		};

		//Cluster styles, small, medium and large
		var clusterStyles = [clusterStyle, clusterStyle, clusterStyle];

		var mcOptions = {
			maxZoom: 10,
			styles: clusterStyles
		};
		new MarkerClusterer(map, markersArr, mcOptions);
	}

	function dateFormat(dateObject) {
		var date = new Date(dateObject);
		var day = date.getDate();
		var month = date.getMonth();
		var year = date.getFullYear();
		var monthNames = new Array('January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December');
		var formattedDate = day + ' ' + monthNames[month] + ' ' + year;

		return formattedDate;
	}

	function addSatelliteMarker(marker, point) {
		mapMarkers.push(marker);
		satelliteLineCoords.push(point);
		bounds.extend(point);
	}

	function zoomMarkers(map, zoom, markersLength, marker, markerNumber, point) {
		var numHigh = Math.floor(markersLength / numPointsAtHighZoom);
		var numMid = Math.floor(markersLength / numPointsAtMidZoom);
		var numLow = Math.floor(markersLength / numPointsAtLowZoom);

		var markerAdded = false;

		if (markersLength > 100) {
			// show less points at higher zoom, more points at mid zoom, and more points at lower zoom
			if (zoom > maxZoomLevelForMidZoom) {
				if (markerNumber % numHigh === 1) {
					addSatelliteMarker(marker, point);
					markerAdded = true;
				}
			} else if (zoom > maxZoomLevelForLowZoom) {
				if (markerNumber % numMid === 1) {
					addSatelliteMarker(marker, point);
					markerAdded = true;
				}
			} else {
				if (markerNumber % numLow === 1) {
					addSatelliteMarker(marker, point);
					markerAdded = true;
				}
			}

			if (!markerAdded && (markerNumber === 0 || markerNumber === markersLength - 1)) {
				// ADD START AND FINISH POINTS
				addSatelliteMarker(marker, point);
			}
		} else {
			// show all points until we have enough for 
			addSatelliteMarker(marker, point);
		}
	}

	function drawNavigation(google, map, navigation, birdName) {
		// Clear markers and polyline
		if (mapMarkers) {
			for (var i = 0; i < mapMarkers.length; i++) {
				mapMarkers[i].setMap(null);
			}
			mapMarkers = [];
		}
		if (polyLine) {
			polyLine.setMap(null);
		}

		bounds = new google.maps.LatLngBounds();
		satelliteLineCoords = [];

		for (var i = 0; i < navigation.length; i++) {
			if (navigation[i].name === birdName) {
				var zoomLevel = map.getZoom();

				for (var j = 0; j < navigation[i].points.length; j++) {
					var latLng = new google.maps.LatLng(navigation[i].points[j].latitude, navigation[i].points[j].longitude);

					var markerOnMap = new google.maps.Marker({
						position: latLng,
						icon: new google.maps.MarkerImage('https://chart.googleapis.com/chart?chst=d_text_outline&chld=000000|13|l|ffffff|b|' + encodeURI(dateFormat(navigation[i].points[j].date)))
					});

					zoomMarkers(map, zoomLevel, navigation[i].points.length, markerOnMap, j, latLng);
				}

				for (var k = 0; k < mapMarkers.length; k++) {
					mapMarkers[k].setMap(map);
				}

				polyLine = new google.maps.Polyline({
					path: satelliteLineCoords,
					map: map,
					strokeColor: '#000000'
				});

				break;
			}
		}
	}

	function createPoly(google, map, poly) {
		// add polygon
		poly.setMap(map);

		var newHtml = createInfoBox(poly);

		google.maps.event.addListener(poly, 'click', function (event) {
			if (mapElem.parent().hasClass('standard-content__side-content')) {
				createMapPopup(google, map, this.name, event);
			} else {
				$(closeInfoBoxList).addClass('active');
				$(infoBoxListWrapper).addClass('active');
				$(infoBoxList).empty().append(newHtml);
			}
		});
	}

	function drawPolys(google, map, polys) {

		if (polys !== null) {

			for (var i = 0; i < polys.length; i++) {
				//set polygon
				var poly = new google.maps.Polygon({
					paths: polys[i].coords,
					strokeWeight: 1,
					strokeColor: '#f44242',
					fillColor: '#f44242',
					name: polys[i].title,
					title: polys[i].title,
					infoText: polys[i].infoText,
					imageUrl: polys[i].imageUrl,
					linkUrl: polys[i].linkUrl,
					linkText: polys[i].linkText
				});

				createPoly(google, map, poly);
			}
		}
	}

	/**
 * drawMap
 * @param  {object} elem    HTML container element
 * @param  {number} lat     Lattitude
 * @param  {number} lng     Longitude
 * @param  {number} zoom    Zoom level
 * @param  {array} markers 	Markers object
 * @return {boolean}        default return value
 */
	function drawMap(elem, lat, lng, zoom, markers, polys, navigation) {
		GoogleMapsLoader.load(function (google) {
			var mapSettings = {
				center: new google.maps.LatLng(lat, lng),
				zoom: zoom,
				scrollwheel: false
			};
			var newMap = new google.maps.Map(elem, mapSettings);

			if (typeof markers !== 'undefined') {
				drawMarkers(google, newMap, markers);
			}

			if (typeof polys !== 'undefined') {
				drawPolys(google, newMap, polys);
			}

			if (typeof navigation !== 'undefined') {
				satelliteRoute = $('[data-binding="map-block-navigation"]').first().data('navigation');
				drawNavigation(google, newMap, navigation, $('[data-binding="map-block-navigation"]').first().data('navigation'));
				newMap.fitBounds(bounds);
				$('[data-binding="map-block-navigation"]').first().addClass('active');
				$('[data-binding="map-block-navigation"]').on('click', function (e) {
					e.preventDefault();
					satelliteRoute = $(this).data('navigation');
					$('[data-binding="map-block-navigation"]').removeClass('active');
					$(this).addClass('active');
					drawNavigation(google, newMap, navigation, satelliteRoute);
					newMap.fitBounds(bounds);
				});

				google.maps.event.addListener(newMap, 'zoom_changed', function () {
					drawNavigation(google, newMap, navigation, satelliteRoute);
				});
			}

			google.maps.event.addListener(mapElem, 'click', function () {
				this.setOptions({
					scrollwheel: true
				});
			});

			centerPoint = newMap.getCenter();
			initialZoom = newMap.getZoom();

			google.maps.event.addListener(newMap, 'bounds_changed', function () {
				if (fullScreenToggle) {
					newMap.setCenter(centerPoint);
					newMap.setZoom(initialZoom);
					fullScreenToggle = false;
				}
			});

			//Redraw map after resize
			mapResize(google, elem);
			//Listen for changes to the tabs
			channel.subscribe('tabChange', function () {
				$(window).trigger('resize');
			});

			$(document).bind('webkitfullscreenchange mozfullscreenchange MSFullscreenChange fullscreenchange', function () {
				fullScreenToggle = true;
			});
		});
	}

	function init() {
		// Extract map initial configuration from DOM
		var initialLat = parseFloat(mapElem.attr('data-map-lat'));
		var initialLng = parseFloat(mapElem.attr('data-map-lng'));
		var initialZoom = parseInt(mapElem.attr('data-map-zoom'));
		var markers = mapElem.data('map-markers');
		var area = mapElem.data('map-area');
		var polys;
		navigation = mapElem.data('map-navigation');

		if (typeof area !== 'undefined') {
			polys = area.polys;
		}

		// Draw map
		drawMap(mapElem[0], initialLat, initialLng, initialZoom, markers, polys, navigation);

		//Close overlay
		$(closeInfoBoxList).on('click', function (e) {
			e.preventDefault();
			$(this).removeClass('active');
			$(infoBoxListWrapper).removeClass('active');
			$(this).blur();
		});
	}

	return {
		init: init
	};
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/map-block.js
// module id = 247
// module chunks = 0